import styled from 'styled-components';
import {
  SectionParent,
  BlueButton,
  H1,
} from '../../../components/StyledComponents';
import React from 'react';
import YourAppYourDevicesMobile from '../../../assets/v2/CustomHardware/esper_hardware_cloud.jpg';
import { navigate, graphql, StaticQuery } from 'gatsby';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import CustomBar from '../../../assets/v2/CustomHardware/CustomBar.svg';
import Image from 'gatsby-image';

const ImgItem = styled(Image)`
  width: 80%;
  margin-top: 3rem;
  justify-self: right;
  @media (max-width: 768px) {
    margin-top: 3rem;
    width: calc(80%);
    margin-left: 5rem;
  }
  @media (max-width: 520px) {
    height: 20rem;
    display: none;
  }
`;
const ImageContainer = styled.img`
  width: 100%;
  height: 100%;
  @media (max-width: 800px) {
    width: 100%;
    height: fit-content;
  }
`;
const ImgItemMobile = styled(LazyLoadImage)`
  display: none;
  @media (max-width: 520px) {
    width: calc(100%);
    margin-top: 3rem;
    display: unset;
  }
`;

const SectionOne = styled(SectionParent)`
  background-repeat: no-repeat;
  padding-top: 3rem !important;
  background-size: contain;
  @media (max-width: 768px) {
    padding-top: 3rem !important;
  }
  width: 100%;
  display: grid;
`;

const SectionItemContainer = styled.div`
  grid-template-columns: repeat(24, 1fr);
  display: grid;
`;

const GridLeft = styled.div`
  grid-column: span 12;
  /* padding-left: 3rem; */
  margin-top: 3rem;
  align-content: center;
  display: grid;
  @media (max-width: 768px) {
    grid-column: span 24;
    padding-right: 0rem;
    padding-left: 0rem;
    min-height: 15rem;
  }
  @media (max-width: 520px) {
    min-height: unset;
    height: 30rem;
    margin-top: 3rem;
  }
`;
const GridRight = styled.div`
  grid-column: span 12;
  @media (max-width: 768px) {
    grid-column: span 24;
  }
`;

const HeroSubTitle = styled.div`
  padding-top: 2rem;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.64;
  letter-spacing: normal;
  color: #6a718c;
  @media (max-width: 768px) {
    text-align: center;
  }

  @media (max-width: 520px) {
    text-align: center;
    padding-top: 0.5rem;
    margin-bottom: -1rem;
  }
`;
const BlueButtonWrapper = styled.div`
  margin-left: -10px;
  margin-top: 24px;
  justify-content: center;
  padding-bottom: 3rem;
  display: grid;
  @media (max-width: 768px) {
    text-align: center;
  }
  @media (max-width: 520px) {
    justify-self: center;
  }
`;
const PageTitle = styled(H1)`
  color: #4a5376;

  line-height: 1.28;
  justify-self: center;
  text-align: center;
  @media (max-width: 520px) {
    font-size: 24px;
    padding-right: 0;
  }
`;

const SignUpTitle = styled(H1)`
  color: #4a5376;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 20px;
  font-weight: bold;
  // line-height: 1;
  margin-bottom: -10px;
  justify-self: center;
  text-align: center;
  @media (max-width: 520px) {
    font-size: 24px;
    padding-right: 0;
  }
`;
export default () => (
  <div style={{ zIndex: 1, position: 'relative', background: '#fafcff' }}>
    <SectionOne>
      <PageTitle>Create your Custom Device Solution</PageTitle>
      <SectionItemContainer>
        <GridLeft>
          <ImageContainer
            alt="Create your custom device solution"
            src={CustomBar}
          />
        </GridLeft>
        <GridRight>
          <StaticQuery
            query={graphql`
              query {
                file(
                  relativePath: {
                    eq: "v2/CustomHardware/esper_hardware_cloud.jpg"
                  }
                ) {
                  childImageSharp {
                    fluid(quality: 95) {
                      aspectRatio
                      src
                      srcSet
                      sizes
                      srcWebp
                      srcSetWebp
                    }
                  }
                }
              }
            `}
            render={(data: any) => (
              <ImgItem
                loading="lazy"
                fluid={data.file.childImageSharp.fluid}
                alt="Esper Andi"
              />
            )}
          />

          <ImgItemMobile alt="Esper Andi" src={YourAppYourDevicesMobile} />
        </GridRight>
      </SectionItemContainer>
      <SignUpTitle style={{ color: '#26315c', marginTop: '3rem' }}>
        Start creating now with Esper and MediaTek
      </SignUpTitle>
      <BlueButtonWrapper>
        <BlueButton
          id="custom_hardware__signup"
          onClick={() => navigate('/signup')}
          style={{
            marginLeft: '0',
          }}
        >
          Sign up with Esper
        </BlueButton>
      </BlueButtonWrapper>
    </SectionOne>
  </div>
);
